import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

// ----------------------------------------------------------------------

export function usePathname(): string {
  const { pathname } = useLocation();

  return useMemo(() => pathname, [pathname]);
}

// ----------------------------------------------------------------------

export function useActiveLink(path: string, deep: boolean = true): boolean {
  const { pathname } = useLocation();

  const normalActive = path ? !!matchPath({ path, end: true }, pathname) : false;

  const deepActive = path ? !!matchPath({ path, end: false }, pathname) : false;

  return deep ? deepActive : normalActive;
}

// ----------------------------------------------------------------------

export function fillRoute(route: string, params: Record<string, string>) {
  return route
    .split('/')
    .map(segment => (segment.startsWith(':') ? params[segment.substring(1)] : segment))
    .join('/');
}
